import { useState } from "react";
import Step0 from "./Step0";

const CreateWebinar = ({ setIsWebCreateModal, isWebinar }) => {
  const [step, setStep] = useState(0);

  return (
    <div
      className="modal d-block  ct_congratulation_modal_fade modal-md"
      tabIndex="-1"
      //   class="modal fade modal-md"
      id="ct_create_event_choose"
      aria-labelledby="ct_create_event_chooseLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered ct_modal-dialog">
        <div class="modal-content ">
          <div class="modal-header border-0">
            <button
              type="button"
              class="btn-close ct_circle_close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => setIsWebCreateModal(false)}
            ></button>
          </div>
          {step == 0 && <Step0 step={step} setStep={setStep} isWebinar={isWebinar} />}
        </div>
      </div>
    </div>
  );
};

export default CreateWebinar;
